module.exports = __webpack_public_path__ + "static/wp1-3-a7bde63802999a0404b451f9538a7bee.jpg";